import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, effect, input, viewChild } from '@angular/core';

/**
 * Affiche une piste video (camera ou partage d'ecran) dans un `<video>`.
 *
 * Toujours `muted` : le son passe par `SortieAudioComponent`, une seule fois. Sans cela une
 * piste video portant du son le jouerait en double.
 */
@Component({
  selector: 'app-piste-video',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<video #lecteur autoplay playsinline [muted]="true" class="w-full h-full object-cover" [class.miroir]="miroir()"></video>`,
  styles: [`:host { display: block; width: 100%; height: 100%; } .miroir { transform: scaleX(-1); }`],
})
export class PisteVideoComponent implements OnDestroy {
  readonly piste = input<MediaStreamTrack | null>(null);
  /** Image en miroir, comme un retour de camera frontale (soi-meme seulement). */
  readonly miroir = input(false);

  private readonly lecteur = viewChild.required<ElementRef<HTMLVideoElement>>('lecteur');

  constructor() {
    effect(() => {
      const video = this.lecteur().nativeElement;
      const piste = this.piste();
      video.srcObject = piste ? new MediaStream([piste]) : null;
      if (piste) void video.play?.().catch(() => undefined);
    });
  }

  ngOnDestroy(): void {
    this.lecteur().nativeElement.srcObject = null;
  }
}
